import { render, staticRenderFns } from "./querydept_C.vue?vue&type=template&id=23a703fb&scoped=true"
import script from "./querydept_C.vue?vue&type=script&lang=js"
export * from "./querydept_C.vue?vue&type=script&lang=js"
import style0 from "./querydept_C.vue?vue&type=style&index=0&id=23a703fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a703fb",
  null
  
)

export default component.exports